import styled from "styled-components";

const Attributes = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vh;
`;

export default Attributes;
